"use client";
import { Container, Stack } from "react-bootstrap";
import { BiLogOut } from "react-icons/bi";
import { FaUser, FaUsers } from "react-icons/fa";
import {
  IoDocuments,
  IoDocumentsOutline,
  IoNotifications,
} from "react-icons/io5";
import { PiListBulletsFill } from "react-icons/pi";
import { RiPieChart2Fill } from "react-icons/ri";
import { SiMicrodotblog } from "react-icons/si";
import { TbMessageUser } from "react-icons/tb";
import { useDispatch } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Logo } from "../../../constant/imagePath";
import { signOutRequest } from "../../../store/auth/authSlice";
import classes from "./Sidebar.module.css";
import { ImNewspaper } from "react-icons/im";
import { MdMenuBook, MdLocationOn, MdCategory } from "react-icons/md";
import { BiCategory } from "react-icons/bi";

export default function Sidebar() {
  const active = useLocation()?.pathname;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const tabs = [
    { label: "CMS", href: "/cms", icon: IoDocuments },
    { label: "Categories (CMS)", href: "/categories", icon: BiCategory },
    { label: "Locations (SEO)", href: "/locations", icon: MdLocationOn },
    { label: "Blogs", href: "/blogs", icon: SiMicrodotblog },
    {
      label: "Contact Requests",
      href: "/contact-requests",
      icon: TbMessageUser,
    },
    {
      label: "Newsletter",
      href: "/newsletter",
      icon: ImNewspaper,
    },
    {
      label: "Chef's Planners",
      href: "/chef-planners",
      icon: MdMenuBook,
    },
    // { label: "Dashboard", href: "/dashboard", icon: RiPieChart2Fill },
    // { label: "Users", href: "/users", icon: FaUser },
    // { label: "Orders", href: "/orders", icon: PiListBulletsFill },
    // { label: "Vendors/Partners", href: "/vendors", icon: FaUsers },
    // { label: "Notifications", href: "/notification", icon: IoNotifications },
  ];

  const logout = () => {
    dispatch(signOutRequest());
    return navigate("/", { replace: false });
  };

  return (
    <Container className={classes.sideBar}>
      <div className={classes.sidebarLogo}>
        <Link to={"/"}>
          <img src={Logo} alt="logo" />
        </Link>
      </div>

      <Stack className={classes.sideBarTabContainer}>
        {tabs?.map((tab, index) => (
          <a
            key={index}
            href={tab.href}
            className={classes.sideBarTab}
            data-active={tab.href === active}
          >
            <div className={classes.sideBarTabIcon}>
              <tab.icon
                color={
                  tab.href === active
                    ? "var(--primary-color)"
                    : "var(--primary-color)"
                }
                size={20}
              />
            </div>
            <p>{tab.label}</p>
          </a>
        ))}
      </Stack>
      <div className={classes?.logoutBtn} onClick={logout}>
        <BiLogOut size={20} />
        <span>Log Out</span>
      </div>
    </Container>
  );
}
